import React from 'react'
import './header.css'

import { connect } from 'react-redux'
import {
  toggleOpenMenu,
  toggleOpcionesGuardadas,
  toggleUsuario,
  setHeightHeader,
  getGrupoProyectoActual,
  toggleOpenProyecto,
  closeMenu,
  closeProyecto
} from '../../modules/reducer'

import Measure from 'react-measure'

//import IconGlobe from './IconGlobe'
import IconGps from './IconGps'
import IconUser from './IconUser'
import IconHamburguer from './IconHamburguer'
import MenuIdiomasH from './MenuIdiomasH'
import IconHome from './IconHome'
import IconArrow from '../Images/IconArrow'

import MenuProyectos from './MenuProyectos'

const Header = ({
  loaded,
  url,
  toggleOpenMenu,
  toggleOpcionesGuardadas,
  history,
  toggleUsuario,
  logged,
  setHeightHeader,
  grupoProyecto,
  toggleOpenProyecto,
  closeMenu,
  closeProyecto,
  idioma
}) => {
  const mq = window.matchMedia('(max-width: 823px)')

  let menuIdiomas = null
  let right = '1.5em' //'0.75em'
  let menuProyectos = false

  if (!mq.matches) {
    menuIdiomas = <MenuIdiomasH history={history} />
    right = '1.5em'
    menuProyectos = true
  }

  return (
    <Measure
      bounds
      onResize={contentRect => {
        setHeightHeader(contentRect.bounds.height)
      }}
    >
      {({ measureRef }) => (
        <div
          ref={measureRef}
          className="header col-12 grid-spaceBetween-noGutter"
        >
          <div className="col-3_sm-2" />
          {typeof grupoProyecto !== 'undefined' ? (
            <>
              <div
                className="icon-home"
                onClick={e => {
                  if (!menuProyectos) {
                    closeMenu()
                  }
                  toggleOpenProyecto()
                }}
              >
                <IconHome size="2.3em" color="white" />
              </div>

              {menuProyectos ? (
                <>
                  <div
                    className="menu-h"
                    style={{ left: '6em', width: '17em', cursor: 'pointer' }}
                    onClick={e => toggleOpenProyecto()}
                  >
                    <span style={{ textTransform: 'uppercase' }}>
                      {grupoProyecto.title}
                    </span>
                    <div className="arrow-container-icon">
                      <IconArrow size="1em" color="white" />
                    </div>
                  </div>

                  {false ? <MenuProyectos /> : null}
                </>
              ) : null}
            </>
          ) : null}

          <div
            className="header-logo col-3_sm-6"
            style={{
              backgroundImage: idioma === 'en'? 'url(logo-ingles.png)':'url(logo.png)'
            }}
          />
          <div className="col-3_sm-2" />
          {menuIdiomas}
          {loaded ? (
            mq.matches ? (
              <div
                className="icon-user"
                style={{
                  right,
                  width: '1.5em',
                  height: '1.5em'
                }}
                onClick={e => {
                  closeProyecto()
                  toggleOpenMenu()
                }}
              >
                <IconHamburguer size="1.5em" color="white" />
              </div>
            ) : (
              <>
                <div
                  className="icon-globe"
                  style={{
                    right: `calc(${right} + 10px + 2.4em)`
                  }}
                  onClick={e => toggleOpenMenu()}
                >
                  <IconGps size="2.3em" color="white" />
                </div>
                <div
                  className="icon-user"
                  style={{
                    right
                  }}
                  onClick={e =>
                    logged ? toggleOpcionesGuardadas() : toggleUsuario(false)
                  }
                >
                  <IconUser size="2.3em" color="white" />
                </div>
              </>
            )
          ) : null}
        </div>
      )}
    </Measure>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {

  return {
    loaded: reducer.loaded,
    url: reducer.url,
    logged: typeof reducer.idUsuario === 'undefined' ? false : true,
    grupoProyecto: getGrupoProyectoActual(reducer),
    idioma:reducer.idioma
  }
}

const mapDispatchToProps = {
  toggleOpenMenu,
  toggleOpcionesGuardadas,
  toggleUsuario,
  setHeightHeader,
  toggleOpenProyecto,
  closeMenu,
  closeProyecto
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
